import {
  IParticleShape,
  ParticleShapeData,
} from "./VolumetricParticles.interface";

export class BeakerParticles implements IParticleShape {
  generate(count: number, size: number): ParticleShapeData {
    const positions = new Float32Array(count * 3);
    const types = new Float32Array(count);
    const baseHeight = size * 1.0;
    const baseRadius = size * 0.7;
    const neckHeight = size * 0.25; // Half size neck
    const neckRadius = size * 0.2;

    const totalHeight = baseHeight + neckHeight;
    const yMin = -baseHeight / 2;

    for (let i = 0; i < count; i++) {
      // 60% glass (shell), 40% liquid (inside)
      const isGlass = Math.random() < 0.6;
      types[i] = isGlass ? 1.0 : 0.0;

      let y, r, theta;
      theta = Math.random() * 2 * Math.PI;

      if (isGlass) {
        const rand = Math.random();
        if (rand < 0.3) {
          // Bottom (30%)
          y = yMin + Math.random() * 0.05 * size;
          r = baseRadius * Math.sqrt(Math.random());
        } else if (rand < 0.4) {
          // Mouth Ring (10%) - Top of neck, slightly thicker
          y = yMin + totalHeight + (Math.random() - 0.5) * 0.05 * size;
          // Ring radius is slightly larger than neck radius
          r = neckRadius * (1.1 + Math.random() * 0.2);
        } else {
          // Side walls (60%)
          y = yMin + Math.random() * totalHeight;

          let maxRAtY = 0;
          if (y > baseHeight / 2) {
            // Neck section
            maxRAtY = neckRadius;
          } else {
            // Base section
            const t = (y - yMin) / baseHeight;
            maxRAtY = baseRadius * (1 - t) + neckRadius * t;
          }

          // Place on surface with slight thickness
          r = maxRAtY * (0.95 + Math.random() * 0.1);
        }
      } else {
        // Liquid fills only the base part (up to 80% of base height)
        const liquidHeight = baseHeight * 0.85;
        y = yMin + Math.random() * liquidHeight;

        // We are always in the base section for liquid
        const t = (y - yMin) / baseHeight;
        const maxRAtY = baseRadius * (1 - t) + neckRadius * t;

        // Place inside volume
        r = maxRAtY * Math.sqrt(Math.random()) * 0.9;
      }

      positions[i * 3] = r * Math.cos(theta);
      positions[i * 3 + 1] = y;
      positions[i * 3 + 2] = r * Math.sin(theta);
    }
    return { positions, extraAttributes: { types } };
  }
}
